import Skeleton from '@/components/ui/Skeleton'
import { cn } from '@/lib/utils'
import { BAND, GROUP, RULED } from '@/screens/brokers/components/large-trades/summary-band'

/**
 * The summary band's loading shape: the same box and groups as `SummaryStrip`, bars where the
 * figures go, so the band does not move when they land. Its own light module (Skeleton, `cn` and
 * the shared classes only): a route's `pendingComponent` ships in the entry chunk, so it may not
 * pull the loaded component in.
 */
export default function SummaryBandSkeleton() {
  return (
    <div className="@container" aria-hidden="true">
      <div className={BAND}>
        <div className={cn(GROUP, 'flex flex-col gap-1')}>
          <Skeleton className="h-3 w-28 rounded-xs" />
          <Skeleton className="h-6 w-40 rounded-xs" />
        </div>
        <div className={cn(GROUP, RULED, 'flex flex-col gap-2')}>
          <div className="flex justify-between gap-4">
            <Skeleton className="h-3 w-36 rounded-xs" />
            <Skeleton className="h-3 w-32 rounded-xs" />
          </div>
          <Skeleton className="h-2 w-full rounded-none" />
        </div>
        <div className={cn(GROUP, RULED, 'flex gap-6')}>
          <div className="flex flex-col gap-1">
            <Skeleton className="h-3 w-20 rounded-xs" />
            <Skeleton className="h-5 w-24 rounded-xs" />
          </div>
          <div className="flex flex-col gap-1">
            <Skeleton className="h-3 w-28 rounded-xs" />
            <Skeleton className="h-5 w-16 rounded-xs" />
          </div>
        </div>
      </div>
    </div>
  )
}
